import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as pdfjsLib from 'pdfjs-dist';

import { FilesViewerModalComponent } from '../files-viewer-modal/files-viewer-modal.component';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
  standalone: false,
})
export class AttachmentsComponent implements OnInit {
  @Input() urls: string[] = [];
  @Input() fileNames: string[] = [];
  @Input() classicStyles: boolean = false;
  @Input() readOnly: boolean = false;
  @Output() deleteRequest = new EventEmitter<number>();

  pdfThumbnails: { [key: string]: string } = {};

  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.mjs',
      import.meta.url
    ).toString();

    this.urls.forEach((url, index) => {
      if (this.isPDF(url)) {
        this.generatePDFThumbnail(url);
      }
    });
  }

  isImage(url: string): boolean {
    const isImageDataUrl = url.startsWith('data:image/');
    const hasImageExtension =
      url.endsWith('.png') ||
      url.endsWith('.jpg') ||
      url.endsWith('.jpeg') ||
      url.endsWith('.gif') ||
      url.endsWith('.bmp') ||
      url.endsWith('.webp');
    return isImageDataUrl || hasImageExtension;
  }

  isPDF(url: string): boolean {
    return url.startsWith('data:application/pdf;') || url.endsWith('.pdf');
  }

  async generatePDFThumbnail(url: string) {
    try {
      const pdf = await pdfjsLib.getDocument(url).promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 0.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({
        canvasContext: context,
        viewport: viewport,
      }).promise;

      this.pdfThumbnails[url] = canvas.toDataURL();
    } catch (error) {
      console.error('Error generating PDF thumbnail:', error);
      this.pdfThumbnails[url] = 'assets/logo.pdf.png';
    }
  }

  getFileName(url: string, index: number): string {
    if (this.fileNames && this.fileNames[index]) {
      return this.fileNames[index];
    }
    if (url.startsWith('data:')) {
      const match = url.match(/name=([^;]+);/);
      if (match && match[1]) return match[1];
      return 'Uploaded File';
    }
    const parts = url.split('/');
    return parts[parts.length - 1];
  }

  onThumbnailClick(index: number) {
    this.dialog.open(FilesViewerModalComponent, {
      height: 'calc(100% - 30px)',
      width: 'calc(100% - 30px)',
      maxWidth: '100%',
      maxHeight: '100%',
      data: {
        urls: this.urls,
        currentIndex: index,
        fileNames: this.fileNames,
      },
      panelClass: 'files-viewer-modal-custom',
    });
  }

  onDeleteClick(index: number, event: MouseEvent): void {
    event.stopPropagation();
    this.deleteRequest.emit(index);
  }
}
